import React from 'react';

const VisualElements: React.FC = () => {
  return (
    <div className="visual-elements">
      <div className="grid-pattern"></div>
      <div className="gold-circle circle-1"></div>
      <div className="gold-circle circle-2"></div>
      <div className="gold-line line-h"></div>
      <div className="gold-line line-v"></div>
    </div>
  );
};

export default VisualElements;
